import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapTouchTapEvent implements MapEvent {
    type = MapEventType.touchTap;
    constructor(public payload: mapboxgl.MapTouchEvent) {}
}
